<template>
  <div class="inline-banner-with-cta">
    <div class="inline-banner-with-cta__container">
      <div
        class="inline-banner-with-cta__description"
        v-html="descriptionCopy" />

      <a
        class="inline-banner-with-cta__cta button button--wide"
        :class="finalCtaJsClass"
        @click="handleClick"
        :href="ctaHref"
        :data-login-path="loginPath"
        :data-signup-path="signupPath">
        {{ finalCtaCopy }}
      </a>
    </div>
  </div>
</template>

<script>
import events from "/events/index";

export default {
  name: "InlineBannerWithCta",
  i18n: {
    messages: {
      en: {
        daysCount: " | one day | {count} days",
        monthsCount: " | one month | {count} months",
        description: "You can try Blinkist for <strong>free for {trialLength}</strong>. Don’t worry, if you cancel within the trial period you won’t be charged.",
        cta: "Start {count}-day free trial"
      },
      de: {
        daysCount: " | 1 Tag | {count} Tage",
        monthsCount: " | 1 Monat | {count} Monate",
        description: "Damit du dir einen perfekten Eindruck machen kannst, kannst du Blinkist Premium <strong>{trialLength} kostenlos testen</strong>.",
        cta: "Jetzt Probeabo starten"
      }
    }
  },
  props: {
    ctaCopy: {
      type: String,
      default: null
    },
    ctaJsClass: {
      type: String,
      default: null
    },
    piwikCategory: {
      type: String,
      default: null
    },
    plan: {
      type: Object,
      default: null,
      validator: function (plan) {
        return typeof plan.trialDays === "number";
      }
    },
    redirectToCheckoutPage: {
      type: Boolean,
      default: false
    },
    loggedInUserRedirect: {
      type: String,
      default: null
    }
  },
  computed: {
    finalCtaCopy() {
      return this.ctaCopy || this.$t("cta", { count: this.plan.trialDays });
    },
    descriptionCopy() {
      let trialLength;

      if (this.plan.trialDays % 31 === 0) {
        trialLength = this.$tc("monthsCount", this.plan.trialDays / 31);
      } else {
        trialLength = this.$tc("daysCount", this.plan.trialDays);
      }

      return this.$t("description", { trialLength });
    },
    finalCtaJsClass() {
      return this.ctaJsClass || "js-open-signup-popup";
    },
    loginPath() {
      if (this.redirectToCheckoutPage) {
        return this.plan.loginPath;
      }

      return null;
    },
    signupPath() {
      if (this.redirectToCheckoutPage) {
        return this.plan.signupPath;
      }

      return null;
    },
    ctaHref() {
      return this.loggedInUserRedirect || this.plan.link;
    }
  },
  methods: {
    handleClick() {
      events.track(this.piwikCategory, "1-click");
    }
  }
};
</script>

<style lang="scss">
.inline-banner-with-cta {

  &__container {
    display: flex;
    flex-direction: column;

    padding: $spacing-24;

    background-color: $background-blue;

    border-radius: $spacing-4;

    @include media(min-width, m) {
      flex-direction: row;
      align-items: center;

      padding: $spacing-24 $spacing-64;
    }
  }

  &__description {
    @include font-style(p);

    margin-right: $spacing-24;
    margin-bottom: $spacing-16;

    @include media(min-width, m) {
      margin-bottom: 0;
    }
  }

  &__cta {
    flex-shrink: 0;
  }
}
</style>
